import { mutator } from 'satcheljs';
import initializeCalendarProcessingOptions from '../../actions/initializeCalendarProcessingOptions';
import getStore from '../store/store';
import CalendarProcessingOptions from 'owa-service/lib/contract/CalendarProcessingOptions';

/**
 * Initialize the calendar processing options in store
 */

export default mutator(initializeCalendarProcessingOptions, actionMessage => {
    getStore().calendarProcessingOptions = actionMessage.calendarProcessingOptions;
});

export { CalendarProcessingOptions };
